import { Component, ComponentFactoryResolver, ElementRef, OnInit, Type, ViewChild } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { RestapiService } from '../services/restapi.service';
import { ReleaseNumber } from '../home/appidfilters.model';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../services/google-analytics.service';
import { ViewportScroller } from '@angular/common';
import { A } from '@angular/cdk/keycodes';
import amplitude from 'amplitude-js';

/*
Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Malekar
*/
@Component({
  selector: 'app-rel-notes',
  templateUrl: './rel-notes.component.html',
  styleUrls: ['./rel-notes.component.css'],

})
export class RelNotesComponent implements OnInit {
  [x: string]: any;
  public data: any = []
  public inputNum: any = [];
  relNote: any = '';
  relNumber: any = [];
  releaseNo: string;
  releaseNoStart: number;
  releaseNoEnd: number;
  releaseNoFromArray : string;

  @ViewChild('sider')
  sider: any;
  siderHtml: Type<{}>;
  html: SafeHtml;
  releaseNumberFound : boolean = false;
  linkedHoverCopiedText : string ='Copy Link';
  mainUrl : string = '';
  public  instance1 = amplitude.getInstance().init("ff1f348e52206af809b752482e39fb8e");

  constructor(private apiService: RestapiService, private route: ActivatedRoute,
    private componentFactoryResolver: ComponentFactoryResolver, private sanitizer: DomSanitizer,
    public googleAnalyticsService: GoogleAnalyticsService,
    private router: Router,
    private scroller: ViewportScroller, private elRef: ElementRef) { }

  ngOnInit(): void {
    this.apiService.getReleaseNumber().subscribe((resp) => {
      this.relNumber = resp.body;
      this.releaseNo = this.relNumber[this.relNumber.length - 1].releaseNumber;
      this.releaseNoStart = this.relNumber[0].releaseNumber;
      this.releaseNoEnd = this.relNumber[this.relNumber.length - 1].releaseNumber;

      if (this.route.snapshot.queryParams['releaseNo']) {
        this.releaseNo = this.route.snapshot.queryParams['releaseNo'];
      }
      this.searchVDB();
      
    });
    this.googleAnalyticsFunction('Release Notes', 'Release Notes', 'Release Notes');
    amplitude.getInstance().logEvent("Release Notes");
  }
  googleAnalyticsFunction(actionName: string, eventName: string, eventLabel: string) {

    this.googleAnalyticsService.eventEmitter(
      actionName,      //eventName -> Partner Help
      'Menu',       //evtCategory ->Menu
      eventName,    //evtAction -> Sales
      eventLabel, //evtLabel -> Partner Help
      1           //evtValue
    );
  }

  clearSearch() {
    this.releaseNo = '';
    this.relNote = '';
    this.releaseNumberFound = false;
    this.releaseNoFromArray = '';
  }

  searchVDB() {
    
    this.releaseNumberFound = false;
    for (var relNum of this.relNumber) {
      if(parseInt(relNum.releaseNumber)===parseInt(this.releaseNo)){
        this.releaseNoFromArray = relNum.releaseNumber;
        this.releaseNumberFound = true;
        break;
      }
    }
    if(this.releaseNumberFound){
      
      this.apiService.getReleaseNotes(Number(this.releaseNo)).subscribe((resp) => {
      
      this.relNote = resp.body;
      this.html = this.sanitizer.bypassSecurityTrustHtml(this.relNote.message);

      //console.log(this.relNote.message);
      console.log("Status : "+resp.status);
      if(resp.status==200){
        this.linkedHoverCopiedText = "Copy Link";
        this.createFilterUrl();
        this.releaseNumberFound = true;
      }

      /*  this.siderHtml= this.relNote;
       const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.siderHtml);
     this.sider.viewContainerRef.createComponent(componentFactory); */
    });
    }
    
  }
  ngAfterViewInit() {
    setTimeout(() => {
      
      /* var div = this.elRef.nativeElement.querySelector('#'+this.route.snapshot.queryParams['appname']);
      div.style.backgroundColor="#F0919B";
      div.scrollIntoView(); */
      if(this.route.snapshot.fragment!=null){
        this.scrollTo(this.findFirstPollFormID());
      }      
      //this.findFirstPollFormID();
    }, 3000);
  }

  scrollTo(className: string): void {
    /*  const elementList = document.querySelectorAll(className);
     const element = elementList[0] as HTMLElement;
     element.scrollIntoView({ behavior: 'smooth' }); */
    document.getElementById(className)?.scrollIntoView({ behavior: 'smooth' });
    document.getElementById(className)?.setAttribute("style", "background-color:#F5CD47");
  }

  findFirstPollFormID() {
    var list = document.getElementsByTagName("a");
    var articleLlist = document.getElementsByTagName("article");
    //console.log('For a : ' + list.length);
    //console.log('For articleLlist : ' + articleLlist.length);

    var results = '';
    for (var i = 0; i < list.length; i++) {
      var id = list[i].id;
      if (id != null) {
        if (id.toLowerCase().includes(this.route.snapshot.fragment.toLowerCase())) {
          results = id;
          break;
        }
      }
    }
    if (results === '') {
      for (var i = 0; i < articleLlist.length; i++) {
        var id = articleLlist[i].id;
        if (id != null) {
          if (id.toLowerCase().includes(this.route.snapshot.fragment.toLowerCase())) {
            results = id;
            break;
          }
          
        }
      }
    }
    console.log('Result : ' + results);
    return results;
  }
  createFilterUrl(){
    const hostname = window.location.hostname;
    let queryParameters ='';
    this.mainUrl ='';

    if (hostname === 'localhost') {
      this.mainUrl = location.protocol+'//'+location.hostname+':'+location.port+'/relnotes?releaseNo='+this.releaseNo;
    } else {
      this.mainUrl = location.protocol+'//'+location.hostname+'/relnotes?releaseNo='+this.releaseNo;
    }
    //console.log(this.mainUrl);
  }
  copyToClipboard(){
    //navigator.clipboard.writeText(this.mainUrl).then().catch(e => console.error(e));

    navigator.clipboard.writeText(this.mainUrl).then(function() {
      console.log('Link copied...');
    }, function() {
      console.log('Link copying failed...');
    });
    //this.copyTo(this.mainUrl);
    this.isLinkCopied = !this.isLinkCopied;
    this.linkedHoverCopiedText = "Copied to clipboard";
    (document.getElementById('linkClicked') as HTMLInputElement).setAttribute("class", "tooltip__text_copied");
    setTimeout(() => {
      
      //(document.getElementById('linkClicked') as HTMLInputElement).setAttribute("min-width", "100px");
      
    }, 5000);
  }
  getLinkcopiedCss(){
    if(this.linkedHoverCopiedText=== 'Copied to clipboard'){
      return 'tooltip__text_copied';
    }else{
      return 'tooltip__text';
    }
  }
  
}
